export default __webpack_public_path__ + "static/media/lamproglena.b7f5c23d.jpg";